// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__upOry","colBig":"styles_colBig__-yuq7","colSmall":"styles_colSmall__iYOq7"};